export default __webpack_public_path__ + "static/media/ru.d02d9365.svg";